import { atom } from 'recoil'

import { Average, Indicator } from '../types'

import { color } from '../constants'
import { storage } from '../modules'

const INITIAL = {
  SMA: storage.get('sma'),
  VSMA: storage.get('vsma'),
  DISABLE_SMA: true,
  DISABLE_VSMA: storage.get('disable-vsma'),
}

export const indicatorState = atom<Indicator>({
  key: 'indicatorState',
  default: {
    sma: checkIsValid(INITIAL.SMA) || [
      {
        period: 5,
        lineWidth: 2,
        color: color.sma[9],
        visible: true,
        dashStyle: 'Dash',
      },
      {
        period: 10,
        lineWidth: 2,
        color: color.sma[8],
        visible: true,
        dashStyle: 'Dash',
      },
      {
        period: 20,
        lineWidth: 2,
        color: color.sma[5],
        visible: true,
        dashStyle: 'Dash',
      },
      {
        period: 60,
        lineWidth: 2,
        color: color.sma[1],
        visible: true,
        dashStyle: 'Dash',
      },
      {
        period: 120,
        lineWidth: 2,
        color: color.sma[0],
        visible: true,
        dashStyle: 'Dash',
      },
      {
        period: 150,
        lineWidth: 2,
        color: color.sma[13],
        visible: true,
        dashStyle: 'Dash',
      },
      {
        period: 180,
        lineWidth: 2,
        color: color.sma[7],
        visible: true,
        dashStyle: 'Dash',
      },
    ],
    vsma: checkIsValid(INITIAL.VSMA) || [
      {
        period: 5,
        lineWidth: 2,
        color: color.sma[9],
        dashStyle: 'Dash',
      },
      {
        period: 10,
        lineWidth: 2,
        color: color.sma[8],
        dashStyle: 'Dash',
      },
      {
        period: 20,
        lineWidth: 2,
        color: color.sma[5],
        dashStyle: 'Dash',
      },
      {
        period: 60,
        lineWidth: 2,
        color: color.sma[1],
        dashStyle: 'Dash',
      },
      {
        period: 120,
        lineWidth: 2,
        color: color.sma[0],
        dashStyle: 'Dash',
      },
      {
        period: 150,
        lineWidth: 2,
        color: color.sma[13],
        dashStyle: 'Dash',
      },
      {
        period: 180,
        lineWidth: 2,
        color: color.sma[7],
        dashStyle: 'Dash',
      },
    ],
    disableSma: Boolean(INITIAL.DISABLE_SMA),
    disableVsma: Boolean(INITIAL.DISABLE_VSMA),
  },
})

export function checkIsValid(value: string | null) {
  if (!value) {
    return null
  }

  try {
    const obj = JSON.parse(value)
    let periods = [5, 10, 20, 60, 120, 150, 180]

    if (typeof obj !== 'object' || !obj?.length) {
      throw new Error()
    }

    obj.forEach(({ period, lineWidth, color }: Average) => {
      const nextPeriods = removeSearchedPeriod(periods, period)

      if (
        !nextPeriods ||
        typeof lineWidth !== 'number' ||
        lineWidth < 0 ||
        lineWidth > 10 ||
        !isColor(color)
      ) {
        throw new Error()
      }

      periods = nextPeriods
    })

    return obj
  } catch {
    return null
  }
}

function removeSearchedPeriod(array: number[], value: number) {
  const index = array.indexOf(value)

  if (index > -1) {
    array.splice(index, 1)
    return array
  }

  return false
}

function isColor(strColor: string) {
  const s = new Option().style
  s.color = strColor
  return s.color !== ''
}
